import { type FC } from 'react';

import { StyledIndicator, StyledRadioGroup, StyledRoot } from './Radio.styled';
import type { RadioGroupProps, RadioProps } from './types';

export const Radio: FC<RadioProps> = ({
  size = 'md',
  value,
  disabled,
  readOnly,
  required,
  'aria-labelledby': ariaLabelledBy,
  'aria-describedby': ariaDescribedBy,
}) => (
  <StyledRoot
    value={value}
    $size={size}
    disabled={disabled}
    readOnly={readOnly}
    required={required}
    aria-labelledby={ariaLabelledBy}
    aria-describedby={ariaDescribedBy}
  >
    <StyledIndicator $size={size} keepMounted />
  </StyledRoot>
);

Radio.displayName = 'Radio';

export const RadioGroup: FC<RadioGroupProps> = ({ children, ...props }) => (
  <StyledRadioGroup {...props}>{children}</StyledRadioGroup>
);

RadioGroup.displayName = 'RadioGroup';
